// extracted by mini-css-extract-plugin
module.exports = {"root":"FPassword_root__2XffC","form":"FPassword_form__35MP1"};